"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'activate.error.title': 'Attivazione fallita',
    'activate.error.generic': 'È verificato un errore durante l\'attivazione dell\'account',
    'activate.error.no_token': 'Nessun token di attivazione fornito',
    'activate.error.network': 'È verificato un errore di rete',
    'activate.error.invalid_link': 'Link di attivazione non valido',
    'activate.error.invalid_link_description': 'Il link di attivazione su cui hai cliccato non è valido o è scaduto. Prova a registrarti di nuovo o contatta il supporto.',
};
